import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RootState } from "app/redux/reducer";
import { Dispatch, bindActionCreators } from 'redux';
import PageTitle from 'components/customs/PageTitle';
import { TextField, MessageBar, MessageBarType, PrimaryButton, Checkbox, DefaultButton } from 'office-ui-fabric-react';
import { setPageData, setPageErrors, initialPageData } from 'app/redux/page/actions';
import * as _yup from "yup";
import { StatusEnum } from 'app/shared';
import { castThunkAction } from 'app/utils/casting';
import _ from "lodash";
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css';
import { v4 as uuidv4 } from "uuid";
import { createMenu, IMenu, IMenuItem } from 'app/services/menu';
import { getPostsForPanel, IPost } from 'app/services/post';
import MenuAccordion from 'components/customs/MenuAccordion';
import MenuItemModal from 'components/customs/Modals/MenuItemModal';
import AbsoluteLoader from 'components/customs/Loader/AbsoluteLoader';
import Sidebar from 'components/customs/Sidebar/Sidebar';
import PageLayout from 'containers/PageLayout';
import { RouteComponentProps } from 'react-router-dom';

function mapStateToProps(state: RootState, ownProps: RouteComponentProps) {
    return {
        ...ownProps,
        defaultLanguage: state.system.defaultLanguage,
        language: state.system.language,
        pageData: state.page.pageData as IMenu,
        pageErrors: state.page.pageErrors,
        contentTypes: state.contentType.contentTypes.list
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        ...bindActionCreators({
            setPageData,
            setPageErrors,
            initialPageData,
            createMenu,
            getPostsForPanel
        }, dispatch)
    };
}

type CreateMenuProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

interface OwnState {
    messageType: MessageBarType;
    activeAccordion: string;
    accordionLoader: string;
    accordionData: IPost[];
    customLink: {
        title: string;
        url: string;
    };
    selectedAccordionItems: IMenuItem[];
    menuItemModal: {
        show: boolean;
        data: IMenuItem;
        parentId: string;
    };
}

class CreateMenu extends Component<CreateMenuProps, OwnState> {

    state = {
        messageType: MessageBarType.warning,
        activeAccordion: "custom-link",
        accordionLoader: "",
        accordionData: [] as IPost[],
        customLink: {
            title: "",
            url: ""
        },
        selectedAccordionItems: [] as IMenuItem[],
        menuItemModal: {
            show: false,
            data: {} as IMenuItem,
            parentId: ""
        }
    }

    componentDidMount() {
        this.resetData();
    }

    getAccordionPosts(contentTypeId: string) {
        this.setState({
            accordionLoader: contentTypeId,
            activeAccordion: contentTypeId,
            selectedAccordionItems: []
        }, () => {
            castThunkAction<IPost[]>(this.props.getPostsForPanel(contentTypeId)).then(response => {
                if (response) {
                    this.setState({
                        accordionLoader: "",
                        accordionData: response || []
                    })
                }
            })
        })

    }

    onCloseMenuItemModal() {
        this.setState({
            menuItemModal: {
                show: false,
                data: {} as IMenuItem,
                parentId: ""
            }
        })
    }

    deleteMenuItem(id: string, parentId: string) {
        const items = _.cloneDeep(this.props.pageData.items || []);
        if (!parentId) {
            const findIndex = this.props.pageData.items.findIndex(x => x.id === id);
            items.splice(findIndex, 1);
            this.props.setPageData("items", items);
        }
        else {
            const parentMenuItem = this.findMenuItem(items, parentId);
            parentMenuItem?.children.splice(parentMenuItem.children.findIndex((x) => x.id === id), 1);
            this.props.setPageData("items", items);
        }
    }

    updateMenuItem(id: string, parentId: string, data: IMenuItem) {
        const items = _.cloneDeep(this.props.pageData.items || []);
        if (!parentId) {
            const findIndex = this.props.pageData.items.findIndex(x => x.id === id);
            items[findIndex] = data;
            this.props.setPageData("items", items);
        } else {
            const parentMenuItem = this.findMenuItem(items, parentId);
            if (parentMenuItem) {
                const nodeIndex = parentMenuItem?.children.findIndex((x) => x.id === id);
                parentMenuItem.children[nodeIndex] = {
                    ...parentMenuItem.children[nodeIndex],
                    ...data
                };
                this.props.setPageData("items", items);
            }
        }
    }

    findMenuItem(items: IMenuItem[], id: string): IMenuItem | undefined {
        const finded = items.find(x => x.id === id);
        if (finded)
            return finded;

        for (let i = 0; i < items.length; i++) {
            const curr = this.findMenuItem(items[i].children, id);

            if (curr)
                return curr;
        }

        return undefined;
    }

    /** Özel bağlantı ya da sayfaları, global şemaya ekelr. */
    _addToMenu(fromCustomLink?: boolean) {
        let menuItems: IMenuItem[] = _.cloneDeep(this.props.pageData.items);
        if (fromCustomLink) {
            menuItems.push({
                id: uuidv4(),
                title: this.state.customLink.title,
                url: this.state.customLink.url,
                isBlank: false,
                className: "",
                icon: "",
                children: []
            });
        }
        else {
            menuItems = [...menuItems, ...this.state.selectedAccordionItems];
        }
        this.setState({
            customLink: { url: "", title: "" },
            selectedAccordionItems: []
        }, () => {
            this.props.setPageData("items", menuItems);
        })
    }

    resetData() {
        this.setState({
            messageType: MessageBarType.warning
        }, () => {
            this.props.initialPageData<IMenu>({
                title: "",
                status: StatusEnum.Published,
                url: "/",
                language: this.props.defaultLanguage,
                relationId: "",
                items: []
            })
        })
    }

    renderTextByMessageType() {
        switch (this.state.messageType) {
            case MessageBarType.success:
                return "Kaydetme işlemi başarıyla gerçekleşmiştir. Düzenleme sayfasına yönlendiriliyorsunuz..."
            case MessageBarType.error:
                return "Kayıt işlemi yapılırken bir hata oluşmuştur. Lütfen servis sağlayıcınızla iletişime geçin."
            default:
                return null;
        }
    }

    renderMessageBar() {
        if (this.state.messageType !== MessageBarType.warning)
            return (
                <MessageBar
                    messageBarType={this.state.messageType}
                    isMultiline={false}
                >
                    {this.renderTextByMessageType()}
                </MessageBar>
            )
        return null;
    }

    /**
     * Validation Şemasını Kontrol Ederek, Eğer Validate ise Doğrulama modalını aktive eder, Değilse İlgili Yerlere Hata Dönecek Yani,
     * formErrors Objesini Dolduracak Action'u Tetikler.
     */
    onSubmit(isDraft?: boolean) {
        const {
            pageData,
            setPageErrors
        } = this.props;
        const validationSchema = _yup.object({
            title: _yup.string().required(
                "Bu alan zorunludur!"
            )
        });
        let formErrors = {};
        validationSchema
            .validate(pageData, {
                abortEarly: false
            })
            .then(() => {
                setPageErrors({});
                castThunkAction<IMenu>(this.props.createMenu({
                    ...this.props.pageData,
                    status: isDraft ? StatusEnum.Draft : StatusEnum.Published
                })).then(res => {
                    this.setState({
                        messageType: res?.id ? MessageBarType.success : MessageBarType.error
                    }, () => {
                        if (res?.id) {
                            setTimeout(() => {
                                this.props.history.push(`/menu/edit/${res.id}`)
                            }, 1200)
                        }
                    })

                })
            })
            .catch(err => {
                err.inner.forEach((e: any) => {
                    const { path, message } = e;
                    formErrors[path] = message;
                });
                setPageErrors(formErrors);
            });
    };


    renderForm() {
        const { pageData, pageErrors, setPageData } = this.props;
        return (
            <div className="form-groups">
                <div style={{ paddingTop: 0, paddingRight: 0 }} className="form-group">
                    <div style={{ background: "#f5f5f5" }} className="title-form row">
                        <TextField
                            placeholder="Menü Adı"
                            value={pageData.title || ""}
                            label="Menü Adı"
                            className="custom-textfield col-md-12 border"
                            errorMessage={pageErrors.title}
                            onChange={(event: any) => setPageData("title", event.target.value)}
                        />
                    </div>
                </div>
            </div>
        )
    }

    renderCustomLink() {
        // const isValidateUrl = validateUrl(this.state.customLink.url) ? true : false;
        return (
            <MenuAccordion
                showContent={this.state.activeAccordion === "custom-link" ? true : false}
                title="Özel Bağlantı Ekle"
                onChange={() => {
                    this.setState({
                        activeAccordion: "custom-link"
                    })
                }}
            >
                <TextField
                    placeholder="Başlık"
                    value={this.state.customLink.title || ""}
                    label="Başlık"
                    className="custom-textfield border"
                    onChange={(event: any) => this.setState({ customLink: { ...this.state.customLink, title: event.target.value } })}
                />
                <TextField
                    placeholder="URL"
                    value={this.state.customLink.url || ""}
                    label="URL"
                    className="custom-textfield border"
                    // errorMessage={this.state.customLink.url && !isValidateUrl ? "Lütfen geçerli bir URL giriniz!" : ""}
                    onChange={(event: any) => this.setState({ customLink: { ...this.state.customLink, url: event.target.value } })}
                />
                <DefaultButton
                    text="Menüye Ekle"
                    disabled={!this.state.customLink.title}
                    style={{
                        fontSize: 11,
                        padding: "0px 10px",
                        marginLeft: "auto",
                        marginTop: 7.5,
                        float: "right"
                    }}
                    onClick={() => this._addToMenu(true)}
                />
            </MenuAccordion>
        )
    }

    renderContentTypes() {
        if (!this.props.contentTypes || this.props.contentTypes.length === 0) return null;
        return (
            (this.props.contentTypes || []).map((item, index) => (
                <MenuAccordion
                    showContent={this.state.activeAccordion === item.id ? true : false}
                    key={index}
                    title={item.title}
                    onChange={() => this.getAccordionPosts(item.id as string)}
                >
                    <div className="form-wrapper">
                        {this.state.accordionData.length > 0 ? (
                            <React.Fragment>
                                <div className="menu-items">
                                    {this.state.accordionData.map((menuItem, menuIndex) => {
                                        const selectedIndex = this.state.selectedAccordionItems.findIndex(x => x.url === menuItem.url);
                                        return (
                                            <div key={menuIndex} className="menu-item row">
                                                <Checkbox
                                                    className="custom-checkbox"
                                                    label={menuItem.title}
                                                    onChange={(ev, checked) => {
                                                        const selectedItems = _.cloneDeep(this.state.selectedAccordionItems);
                                                        if (!checked) {
                                                            selectedItems.splice(selectedIndex, 1)
                                                        }
                                                        else {
                                                            selectedItems.push({ url: menuItem.url, title: menuItem.title, id: uuidv4(), children: [], isBlank: false, icon: "", className: "" })
                                                        }
                                                        this.setState({ selectedAccordionItems: selectedItems })
                                                    }}
                                                    checked={selectedIndex !== -1 ? true : false}
                                                />
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className="menu-items-footer row">
                                    <span
                                        onClick={() => this.setState({ selectedAccordionItems: (this.state.accordionData || []).map(x => ({ id: uuidv4(), url: x.url, title: x.title, icon: "", className: "", isBlank: false, children: [] })) })}
                                        className="select-all"
                                    >
                                        Tümünü Seç
                                    </span>
                                    <DefaultButton
                                        text="Menüye Ekle"
                                        disabled={this.state.selectedAccordionItems.length === 0}
                                        style={{
                                            fontSize: 11,
                                            padding: "0px 10px",
                                            marginLeft: "auto",
                                            marginTop: 7.5
                                        }}
                                        onClick={() => this._addToMenu()}
                                    />
                                </div>

                            </React.Fragment>
                        ) : (
                            <div className="menu-not-found row">
                                <i className="icon-info"></i>
                                <div className="text">
                                    Geçerli içerik tipine ait bir içerik bulunamadı.
                                    </div>
                            </div>
                        )}

                    </div>
                    <AbsoluteLoader show={this.state.accordionLoader && this.state.accordionLoader === item.id ? true : false} />
                </MenuAccordion>
            ))
        )
    }

    renderMenuItems() {
        return (
            <div className="menu-tree-designer">
                <div className="menu-info">
                    <i className="icon-info"></i>
                    Menü'ye eklenmiş olan elemanları aşağıdan görebilirsiniz. Sol taraftan bir sayfa ya da özel bir bağlantı'yı menü'ye ekleyebilirsiniz.
                </div>
                <MenuItemModal
                    show={this.state.menuItemModal.show ? true : false}
                    data={this.state.menuItemModal.data}
                    onDismiss={() => this.onCloseMenuItemModal()}
                    onSave={() => {
                        this.updateMenuItem(this.state.menuItemModal.data.id as string, this.state.menuItemModal.parentId, this.state.menuItemModal.data);
                        this.onCloseMenuItemModal();
                    }}
                    onDelete={() => {
                        this.deleteMenuItem(this.state.menuItemModal.data.id as string, this.state.menuItemModal.parentId);
                        this.onCloseMenuItemModal();
                    }}
                    onChange={(key: string, value) => {
                        this.setState({
                            menuItemModal: {
                                ...this.state.menuItemModal,
                                data: {
                                    ...this.state.menuItemModal.data,
                                    [key]: value
                                }
                            }
                        })
                    }}
                />
                {this.props.pageData.items && this.props.pageData.items.length > 0 && (
                    <SortableTree
                        treeData={this.props.pageData.items}
                        onChange={treeData => this.props.setPageData("items", treeData)}
                        isVirtualized={false}
                        rowHeight={45}
                        scaffoldBlockPxWidth={20}
                        generateNodeProps={rowInfo => {
                            console.log("rowInfo", rowInfo);
                            return ({
                                buttons: [
                                    <button onClick={() => this.setState({ menuItemModal: { show: true, data: rowInfo.node as IMenuItem, parentId: rowInfo.parentNode?.id || "" } })}>
                                        <i className="icon-setting" />
                                    </button>
                                ]
                            })
                        }}
                    />
                )}
            </div>
        )
    }

    renderMenuDesigner() {
        return (
            <div className="menu-designer row">
                <div className="col-md-3 menu-designer-panel">
                    <div className="form-groups menu-item-group row">
                        {this.renderContentTypes()}
                        {this.renderCustomLink()}
                    </div>
                </div>
                <div className="col-md-9 menu-designer-items">
                    {this.renderForm()}
                    {this.renderMenuItems()}
                </div>
            </div>
        )
    }

    render() {
        return (
            <PageLayout history={this.props.history} match={this.props.match} location={this.props.location}>
                <div className="page push-all">
                    <PageTitle
                        title="Yeni Menü Ekle"
                        titleRenderer={
                            () => (
                                <span className="edit-title">
                                    Yönet:
                                    <strong>Yeni Menü Ekle</strong>
                                </span>
                            )
                        }
                        showBack
                        backUrl="/menus"
                        history={this.props.history}
                        subTitle="Yeni bir menü eklemek için aşağıdaki bilgileri doldurunuz, dilerseniz taslak olarakta oluşturabilirsiniz."
                    />
                    <PrimaryButton
                        onClick={() => { this.resetData() }}
                        iconProps={{ iconName: "Add" }}
                        className="absolute-create"
                        text="Yeni Menü Ekle"
                        styles={{
                            root: {
                                background: "#62a98e",
                                borderColor: "#5b9e85",
                                color: "#fff"
                            },
                            rootHovered: {
                                background: "#5b9e85",
                                borderColor: "#5b9e85"
                            },
                            rootDisabled: {
                                background: "#ececec"
                            }
                        }}
                    />
                    <div className="content row">
                        <div className="left col no-padding">
                            {this.renderMessageBar()}
                            {this.renderMenuDesigner()}
                        </div>
                        <Sidebar
                            categoryBar={{
                                hide: true
                            }}
                            publishBar={{
                                onSave: (isDraft) => this.onSubmit(isDraft),
                                disabledSaveButton: this.state.messageType === MessageBarType.success ? true : false,
                                hideDeleteButton: true,
                                hidePreviewButton: true
                            }}
                            layoutBar={{
                                hide: true
                            }}
                            archiveBar={{
                                hide: true
                            }}
                            thumbnailBar={{
                                hide: true
                            }}
                        />
                    </div>
                </div>
            </PageLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateMenu);